import { useField } from 'formik';
import { Field, type FieldConfig } from '@kolking/react-ui';

import { type ImageData } from '../../models';
import { ImageUpload } from '../ImageUpload';
import { useSpec } from './YupSpecContext';

export interface FormImagePickerProps extends FieldConfig {
  name: string;
}

export const FormImagePicker = ({
  className,
  label,
  help,
  name,
  required,
}: FormImagePickerProps) => {
  const [{ value }, , { setValue }] = useField<ImageData[] | undefined>(name);
  const spec = useSpec();

  return (
    <Field
      className={className}
      required={spec.isRequired(name, required)}
      label={spec.label(name, label)}
      help={help}
    >
      <ImageUpload files={value} onChange={(files) => void setValue(files)} />
    </Field>
  );
};
